module.exports = __webpack_public_path__ + "static/media/gameplay_bg_b_01.6bd514fb.png";